(function($) {

  function castilsecPricingTable() {
    if ($('.castilsec-pricing-table').length) {
      $('.castilsec-pricing-table .ptsRows .ptsCell span').each(function() {
        if ($(this).text() == 'Kyllä' || $(this).text() == 'kyllä') {
          $(this).addClass('value-yes');
        } else if ($(this).text() == 'Ei' || $(this).text() == 'ei') {
          $(this).addClass('value-no');
        }
      });

      $('.castilsec-pricing-table .castilsec-form-trigger').click(function() {
        var $triggerId = $(this).attr('id');
        var $formValue = 'castilsec-' + $triggerId.substring(4);

        var $checkboxId = $('#nf-form-4-cont input:checkbox[value="'+$formValue+'"]').attr('id');
        $('label[for="'+$checkboxId+'"').click();

      })
    }
  }

  castilsecPricingTable();

  $(window).resize(function() {

  });

})(jQuery);
